import { RequestStatus } from "./commons";

/**
 * A mid-flow screen can mount without `?linkId=` after a raw `navigate`.
 * The claimed session is still the link. Returning it avoids recording
 * "no token in the URL" on top of a session the user is already in.
 * A cold open (status not LOADED) stays a missing-token error.
 */
export function claimedLinkIdWithoutUrlToken(
  status: RequestStatus,
  storedLinkId: string | null | undefined,
): string | null {
  if (status !== RequestStatus.LOADED || !storedLinkId) return null;
  return storedLinkId;
}
